import {createAsyncThunk} from "@reduxjs/toolkit";
import ApiMetrics from "../../../integration/api/ApiMetrics";
import {ResponseHandlerName} from "../../responseHandlerService/model";

class HomeActions {
  static getMetricsAndIndexes = createAsyncThunk(
    `home/${ResponseHandlerName.GetMetricsAndIndexes}`,
    async (_, { rejectWithValue }) => {
      try {

        const res = await ApiMetrics.getMetrics();
        return res.data;
      } catch (error) {
        console.log("getMetrics Error: ", error);
        return rejectWithValue(error);
      }
    }
  );
}

export default HomeActions;
